const Alarms = [
  'https://brickschema.org/schema/Brick#Communication_Loss_Alarm',
  'https://brickschema.org/schema/Brick#Power_Loss_Alarm',
  'https://brickschema.org/schema/Brick#Low_Battery_Alarm',
]

const ExceptionEvent = 'https://w3id.org/rec#ExceptionEvent'

export { Alarms, ExceptionEvent }
